// removed by extract-text-webpack-plugin
module.exports = {"DropdownHolder":"Dropdown__DropdownHolder__3VAy-","Dropdown":"Dropdown__Dropdown__nAsJ-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Dropdown/Dropdown.css
// module id = 89
// module chunks = 0